// snippets
import React from "react";
import { ColorCubeIcon } from "components/Icons/ColorCubeIcon";
import { packClasses } from "Utils";

export default function PrimaryButton({
    label,
    type,
    className,
    children,
    blocking,
    variant,
    ...remainder
}) {
    return (
        <button
            type={type ? type : "button"}
            className={packClasses(
                "focus:outline-none relative inline-flex justify-center rounded-md border border-transparent font-medium text-white shadow-sm  focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50",
                blocking
                    ? "bg-gray-200 hover:bg-gray-200"
                    : "bg-green-600 hover:bg-green-700",
                className ? className : "",
                variant === "xs" ? "py-1 px-2 text-xs" : "py-2 px-4 text-sm"
            )}
            {...remainder}
        >
            <ColorCubeIcon
                className={packClasses(
                    blocking ? " opacity-1" : " opacity-0",
                    "absolute mx-auto h-5 w-5 animate-rotate-pulse"
                )}
                key="icn0"
            />
            <span
                className={packClasses(blocking ? " opacity-0" : " opacity-1")}
            >
                {children ? children : label}
            </span>
        </button>
    );
}
